"use client";

import { c as _c } from "react/compiler-runtime";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { emailAction } from "@/lib/actions/email";
import { useActionState } from "react";
export const ContactSection = () => {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      error: "",
      success: ""
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [state, action, pending] = useActionState(emailAction, t0);
  let t1;
  if ($[1] !== pending || $[2] !== state.email || $[3] !== state.message || $[4] !== state.name || $[5] !== state.success) {
    t1 = state.success ? <Alert className="flex-1 flex flex-col items-center justify-center"><Icon icon="lucide:check" className="size-4" /><AlertTitle>Success</AlertTitle><AlertDescription>{state.success}</AlertDescription></Alert> : <><div className="space-y-2"><Label htmlFor="name">Name</Label><Input name="name" type="text" placeholder="Your name" defaultValue={state.name} /></div><div className="space-y-2"><Label htmlFor="email">Email</Label><Input name="email" type="email" placeholder="your@email.com" defaultValue={state.email} /></div><div className="space-y-2"><Label htmlFor="message">Message</Label><Textarea name="message" placeholder="Your message..." className="min-h-32" defaultValue={state.message} /></div><div className="flex items-center gap-1"><Button type="submit" className="flex-1" disabled={pending}>{pending ? <Icon icon="ph:spinner-gap" className="mr-2 h-4 w-4 animate-spin" /> : <Icon icon="lucide:send" className="mr-2 h-4 w-4" />}Send Message</Button><Button variant="outline" type="reset" className="flex-1">Cancel</Button></div></>;
    $[1] = pending;
    $[2] = state.email;
    $[3] = state.message;
    $[4] = state.name;
    $[5] = state.success;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== state.error) {
    t2 = state.error && <Alert variant="destructive"><Icon icon="lucide:alert-circle" className="size-4" /><AlertTitle>Error</AlertTitle><AlertDescription>{state.error}</AlertDescription></Alert>;
    $[7] = state.error;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <form className="flex flex-col gap-4" action={action}>{t1}{t2}</form>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};